module.exports = __webpack_public_path__ + "media/images/dime-simple-business-logo-c18cd10d2481971e5f4dcc1516afea39.png";